import { render } from "./PasswordReminderView.vue?vue&type=template&id=b0a0e77e&scoped=true"
import script from "./PasswordReminderView.vue?vue&type=script&lang=js"
export * from "./PasswordReminderView.vue?vue&type=script&lang=js"

import "./PasswordReminderView.vue?vue&type=style&index=0&id=b0a0e77e&lang=scss&scoped=true"

import exportComponent from "/Users/mateuszsalamonski/WebstormProjects/ems_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0a0e77e"]])

export default __exports__